import vase0Front from '../images/vases/vase0Front.png';
import vase1Front from '../images/vases/vase1Front.png';
import vase2Front from '../images/vases/vase2Front.png';
import vase3Front from '../images/vases/vase3Front.png';
import vase4Front from '../images/vases/vase4Front.png';
import vase5Front from '../images/vases/vase5Front.png';
import vase6Front from '../images/vases/vase6Front.png';
import vaseBack from '../images/vases/vaseBack.png';


const vases = [
        {
        "name": "vase0",
        "src": vase0Front,
        "backSrc": vaseBack,
        "alt": "tall beige/tan vase",
        "type": "vases",
    },
        {
        "name": "vase6",
        "src": vase6Front,
        "backSrc": vaseBack,
        "alt": "curvey checkered black and white vase",
        "type": "vases",
    },
    {
        "name": "vase1",
        "src": vase1Front,
        "backSrc": vaseBack,
        "alt": "tall white vase with bold black lines",
        "type": "vases",
    },
        {
        "name": "vase2",
        "src": vase2Front,
        "backSrc": vaseBack,
        "alt": "tall light grey ornate vase",
        "type": "vases",
    },
    {
        "name": "vase3",
        "src": vase3Front,
        "backSrc": vaseBack,
        "alt": "tall light grey curved vase with dark grey roses and black swirls",
        "type": "vases",
    },
    {
        "name": "vase4",
        "src": vase4Front,
        "backSrc": vaseBack,
        "alt": "tall curved light grey vase",
        "type": "vases",
    },
    {
        "name": "vase5",
        "src": vase5Front,
        "backSrc": vaseBack,
        "alt": "white wavy wide vase",
        "type": "vases",
    },
]

export default vases;